import { useMemo } from 'react';

import Breadcrumbs from 'my-components/Breadcrumbs';

import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import logoSrc from 'images/logo/icon.svg';

const rootCss = ({ palette, spacing }) => ({
  position: 'relative',
  backgroundColor: palette.background.paper,

  '.OCPFH-progress': {
    position: 'absolute',
    height: 12,
    top: 0,
    left: 0,
    right: 0,
  },
  '.OCPFH-header': {
    display: 'flex',
    alignItems: 'center',
    '& > * + *': { marginLeft: spacing(2) },
  },
  '.OCPFH-img': { height: 44 },
  '.OCPFH-spacer': { flex: 1 },
  '.OCPFH-closeButton': { width: 48 },
  '.OCPFH-breadcrumbs': {
    marginTop: spacing(2),
    marginLeft: spacing(-0.5),
    marginBottom: spacing(-1),
  },
});

export default function OnlineCoursePurchaseFormHeader(props) {
  const { activeStep, fullyDiscounted, onChangeStep, onClose, purchasing } = props;

  const breadcrumbs = useMemo(() => {
    if (fullyDiscounted) return ['Information', 'Confirmation'];
    return ['Information', 'Payment', 'Confirmation'];
  }, [fullyDiscounted]);

  return (
    <div css={rootCss}>
      <LinearProgress className="OCPFH-progress" {...(purchasing ? {} : { value: 100, variant: 'determinate' })} />
      <div className="OCPFH-header">
        <img alt="wize logo" className="OCPFH-img" src={logoSrc} />
        <Typography variant="h5">Checkout</Typography>
        <div className="OCPFH-spacer" />
        <IconButton className="OCPFH-closeButton" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      </div>
      <Breadcrumbs
        active={activeStep}
        className="OCPFH-breadcrumbs"
        disabled={activeStep === 2 || purchasing}
        items={breadcrumbs}
        onChange={onChangeStep}
      />
    </div>
  );
}
